import { kebabCase } from 'lodash';

/**
 * Downloads a blob as a file with the specified filename
 * Includes browser environment checks for SSR safety
 */
export const downloadBlob = (blob: Blob, filename: string): void => {
  // Check if running in browser environment
  if (typeof window === 'undefined' || typeof document === 'undefined') {
    console.error('Download is only available in browser environment');
    return;
  }

  try {
    // Create blob URL
    const url = window.URL.createObjectURL(blob);

    // Create temporary download link
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;

    // Append to body, click, and remove
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    // Clean up the blob URL
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error('Failed to download file:', error);
  }
};

/**
 * Downloads a certificate PDF for a given registration ID
 */
export const downloadCertificatePDF = async (
  registrationId: string,
  courseName: string,
  downloadFunction: (id: string) => Promise<Blob>,
): Promise<void> => {
  try {
    const blob = await downloadFunction(registrationId);
    const kebabCourseName = kebabCase(courseName || registrationId);
    const filename = `certificate-${kebabCourseName}.pdf`;
    downloadBlob(blob, filename);
  } catch (error) {
    console.error('Failed to download certificate:', error);
    throw error;
  }
};
